var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * Get user country_code based on his IP address
 */
export function getGeo() {
    return __awaiter(this, void 0, void 0, function* () {
        const defaultReturn = '-';
        const options = { headers: { 'X-Geo-App': 'Arena5' } };
        try {
            const res = yield fetch('https://geoip.cdn.arkadiumhosted.com/json/', options);
            if (!res.ok) {
                return defaultReturn;
            }
            return (yield res.json()).country_code;
        }
        catch (e) {
            return defaultReturn;
        }
    });
}
